export const contactEN = {
  // Contact Hero
  'ct.heroLabel': 'Start Here',
  'ct.heroHeadline': 'Let\'s find out where AI creates {em}real value{/em} for your business.',
  'ct.heroSub': 'The AI Value Discovery is a 6\u201310 week engagement that delivers executive clarity: a prioritized use case portfolio, an architecture blueprint, and a financial impact model \u2014 ready to present to your board.',
  'ct.heroNote': 'No generic proposals. No 100-page reports with no action. A clear plan, backed by economic modeling.',

  // Journey section
  'ct.journeyLabel': 'What Happens Next',
  'ct.journeyHeadline': 'Your path from first contact to {em}AI-driven value{/em}.',
  'ct.step': 'Step',

  // Journey steps
  'ct.step1Title': 'You reach out',
  'ct.step1Desc': 'Fill out the form above or send us a direct email. Tell us a bit about your business, your current data and AI landscape, and what challenges or ambitions are driving you forward. There is no commitment at this stage \u2014 just a conversation starter.',
  'ct.step2Title': 'Schedule a discovery call',
  'ct.step2Desc': 'We schedule a 30-minute conversation with one of our senior specialists. This is not a sales pitch \u2014 it is a focused dialogue to understand your context, your biggest blockers, and what a successful outcome looks like for your organization.',
  'ct.step3Title': 'We build a tailored proposal',
  'ct.step3Desc': 'Through a focused set of conversations, we go deeper into your needs, data maturity, organizational context, and strategic priorities. Based on this, we build a structured AI Value Discovery proposal \u2014 scoped to your reality, with clear deliverables, timeline, and investment.',
  'ct.step3Tag1': 'Scope Definition',
  'ct.step3Tag2': 'Stakeholder Mapping',
  'ct.step3Tag3': 'Tailored Proposal',
  'ct.step4Title': 'Your transformation begins',
  'ct.step4Desc': 'We kick off the AI Value Discovery engagement with a structured process: executive alignment, AI & data maturity assessment, use case identification and prioritization, target architecture, and financial impact modeling. In 6\u201310 weeks, you have a board-ready plan.',
  'ct.step4Tag1': 'AI Maturity Score',
  'ct.step4Tag2': 'Use Case Portfolio',
  'ct.step4Tag3': 'Architecture Blueprint',
  'ct.step4Tag4': 'Financial Impact Model',
  'ct.step4Tag5': '18\u201336 Month Roadmap',

  // End state
  'ct.endLabel': 'End State',
  'ct.endTitle': 'Your organization, {em}data-driven{/em} and ready to capture value at scale with AI.',

  // Contact Form
  'form.name': 'Name',
  'form.company': 'Company',
  'form.role': 'Role / Title',
  'form.email': 'Email',
  'form.industry': 'Industry',
  'form.selectIndustry': 'Select your industry',
  'form.challenge': 'What\'s your biggest AI/data challenge right now?',
  'form.challengePlaceholder': 'Describe your current situation, goals, or blockers...',
  'form.namePlaceholder': 'Your name',
  'form.companyPlaceholder': 'Company name',
  'form.rolePlaceholder': 'Your role',
  'form.emailPlaceholder': 'you@company.com',
  'contact.namePlaceholder': 'John Smith',
  'contact.emailPlaceholder': 'john@company.com',
  'contact.companyPlaceholder': 'Company Inc.',
  'contact.phonePlaceholder': '+1 555 000-0000',
  'contact.messagePlaceholder': 'Tell us about your data & AI challenges...',
  'form.submit': 'Request AI Value Discovery',
  'form.submitting': 'Sending...',
  'form.successLabel': 'You\'re in',
  'form.successTitle': 'We\'ve received your request.',
  'form.successBody': 'A senior specialist will review your submission and reach out within 24 hours to schedule a discovery conversation. Watch your inbox.',
  'form.directEmail': 'Or reach us directly:',

  // Form industries dropdown
  'form.indRetail': 'Retail & E-commerce',
  'form.indFinancial': 'Financial Services',
  'form.indLogistics': 'Logistics & Supply Chain',
  'form.indManufacturing': 'Manufacturing / Industrial',
  'form.indHealthcare': 'Healthcare',
  'form.indB2B': 'B2B / SaaS / Services',
  'form.indStartups': 'Startups & Scale-ups',
  'form.indOther': 'Other',
} as const;

export const contactPT = {
  // Contact Hero
  'ct.heroLabel': 'Comece Aqui',
  'ct.heroHeadline': 'Vamos descobrir onde a IA gera {em}valor real{/em} para o seu neg\u00f3cio.',
  'ct.heroSub': 'O AI Value Discovery \u00e9 um engajamento de 6\u201310 semanas que entrega clareza executiva: um portf\u00f3lio priorizado de casos de uso, um blueprint de arquitetura e um modelo de impacto financeiro \u2014 pronto para apresentar ao seu conselho.',
  'ct.heroNote': 'Sem propostas gen\u00e9ricas. Sem relat\u00f3rios de 100 p\u00e1ginas sem a\u00e7\u00e3o. Um plano claro, respaldado por modelagem econ\u00f4mica.',

  // Journey section
  'ct.journeyLabel': 'O Que Acontece Depois',
  'ct.journeyHeadline': 'Seu caminho do primeiro contato ao {em}valor impulsionado por IA{/em}.',
  'ct.step': 'Passo',

  // Journey steps
  'ct.step1Title': 'Voc\u00ea entra em contato',
  'ct.step1Desc': 'Preencha o formul\u00e1rio acima ou envie-nos um e-mail direto. Conte-nos um pouco sobre seu neg\u00f3cio, seu cen\u00e1rio atual de dados e IA, e quais desafios ou ambi\u00e7\u00f5es est\u00e3o impulsionando voc\u00ea. N\u00e3o h\u00e1 compromisso nesta fase \u2014 apenas o in\u00edcio de uma conversa.',
  'ct.step2Title': 'Agende uma conversa de discovery',
  'ct.step2Desc': 'Agendamos uma conversa de 30 minutos com um de nossos especialistas s\u00eaniores. Isso n\u00e3o \u00e9 um pitch de vendas \u2014 \u00e9 um di\u00e1logo focado para entender seu contexto, seus maiores bloqueios e como \u00e9 um resultado bem-sucedido para sua organiza\u00e7\u00e3o.',
  'ct.step3Title': 'Constru\u00edmos uma proposta personalizada',
  'ct.step3Desc': 'Atrav\u00e9s de um conjunto focado de conversas, aprofundamos suas necessidades, maturidade de dados, contexto organizacional e prioridades estrat\u00e9gicas. Com base nisso, constru\u00edmos uma proposta estruturada de AI Value Discovery \u2014 dimensionada para sua realidade, com entregas claras, cronograma e investimento.',
  'ct.step3Tag1': 'Defini\u00e7\u00e3o de Escopo',
  'ct.step3Tag2': 'Mapeamento de Stakeholders',
  'ct.step3Tag3': 'Proposta Personalizada',
  'ct.step4Title': 'Sua transforma\u00e7\u00e3o come\u00e7a',
  'ct.step4Desc': 'Iniciamos o engajamento de AI Value Discovery com um processo estruturado: alinhamento executivo, avalia\u00e7\u00e3o de maturidade de IA & dados, identifica\u00e7\u00e3o e prioriza\u00e7\u00e3o de casos de uso, arquitetura-alvo e modelagem de impacto financeiro. Em 6\u201310 semanas, voc\u00ea tem um plano pronto para o conselho.',
  'ct.step4Tag1': 'AI Maturity Score',
  'ct.step4Tag2': 'Portf\u00f3lio de Casos de Uso',
  'ct.step4Tag3': 'Architecture Blueprint',
  'ct.step4Tag4': 'Financial Impact Model',
  'ct.step4Tag5': 'Roadmap 18\u201336 Meses',

  // End state
  'ct.endLabel': 'Estado Final',
  'ct.endTitle': 'Sua organiza\u00e7\u00e3o, {em}data-driven{/em} e pronta para capturar valor em escala com IA.',

  // Contact Form
  'form.name': 'Nome',
  'form.company': 'Empresa',
  'form.role': 'Cargo / T\u00edtulo',
  'form.email': 'E-mail',
  'form.industry': 'Ind\u00fastria',
  'form.selectIndustry': 'Selecione sua ind\u00fastria',
  'form.challenge': 'Qual \u00e9 o seu maior desafio de IA/dados neste momento?',
  'form.challengePlaceholder': 'Descreva sua situa\u00e7\u00e3o atual, objetivos ou bloqueios...',
  'form.namePlaceholder': 'Seu nome',
  'form.companyPlaceholder': 'Nome da empresa',
  'form.rolePlaceholder': 'Seu cargo',
  'form.emailPlaceholder': 'voce@empresa.com',
  'contact.namePlaceholder': 'João Silva',
  'contact.emailPlaceholder': 'joao@empresa.com',
  'contact.companyPlaceholder': 'Empresa LTDA',
  'contact.phonePlaceholder': '+55 11 99999-0000',
  'contact.messagePlaceholder': 'Conte-nos sobre seus desafios de dados e IA...',
  'form.submit': 'Solicitar AI Value Discovery',
  'form.submitting': 'Enviando...',
  'form.successLabel': 'Recebemos seu contato',
  'form.successTitle': 'Recebemos sua solicita\u00e7\u00e3o.',
  'form.successBody': 'Um especialista s\u00eanior revisar\u00e1 sua submiss\u00e3o e entrar\u00e1 em contato em at\u00e9 24 horas para agendar uma conversa de discovery. Fique de olho na sua caixa de entrada.',
  'form.directEmail': 'Ou entre em contato diretamente:',

  // Form industries dropdown
  'form.indRetail': 'Varejo & E-commerce',
  'form.indFinancial': 'Servi\u00e7os Financeiros',
  'form.indLogistics': 'Log\u00edstica & Supply Chain',
  'form.indManufacturing': 'Manufatura / Industrial',
  'form.indHealthcare': 'Sa\u00fade',
  'form.indB2B': 'B2B / SaaS / Servi\u00e7os',
  'form.indStartups': 'Startups & Scale-ups',
  'form.indOther': 'Outro',
} as const;

export const contactES = {
  // Contact Hero
  'ct.heroLabel': 'Comience Aqu\u00ed',
  'ct.heroHeadline': 'Descubramos d\u00f3nde la IA genera {em}valor real{/em} para su negocio.',
  'ct.heroSub': 'El AI Value Discovery es un compromiso de 6\u201310 semanas que entrega claridad ejecutiva: un portafolio priorizado de casos de uso, un blueprint de arquitectura y un modelo de impacto financiero \u2014 listo para presentar a su junta.',
  'ct.heroNote': 'Sin propuestas gen\u00e9ricas. Sin informes de 100 p\u00e1ginas sin acci\u00f3n. Un plan claro, respaldado por modelado econ\u00f3mico.',

  // Journey section
  'ct.journeyLabel': 'Qu\u00e9 Sucede Despu\u00e9s',
  'ct.journeyHeadline': 'Su camino desde el primer contacto hasta el {em}valor impulsado por IA{/em}.',
  'ct.step': 'Paso',

  // Journey steps
  'ct.step1Title': 'Usted nos contacta',
  'ct.step1Desc': 'Complete el formulario arriba o env\u00edenos un correo electr\u00f3nico directo. Cu\u00e9ntenos un poco sobre su negocio, su panorama actual de datos e IA, y qu\u00e9 desaf\u00edos o ambiciones lo impulsan. No hay compromiso en esta etapa \u2014 solo el inicio de una conversaci\u00f3n.',
  'ct.step2Title': 'Agende una llamada de descubrimiento',
  'ct.step2Desc': 'Programamos una conversaci\u00f3n de 30 minutos con uno de nuestros especialistas senior. Esto no es un pitch de ventas \u2014 es un di\u00e1logo enfocado para entender su contexto, sus mayores bloqueos y c\u00f3mo se ve un resultado exitoso para su organizaci\u00f3n.',
  'ct.step3Title': 'Construimos una propuesta personalizada',
  'ct.step3Desc': 'A trav\u00e9s de un conjunto enfocado de conversaciones, profundizamos en sus necesidades, madurez de datos, contexto organizacional y prioridades estrat\u00e9gicas. Con base en esto, construimos una propuesta estructurada de AI Value Discovery \u2014 dimensionada para su realidad, con entregables claros, cronograma e inversi\u00f3n.',
  'ct.step3Tag1': 'Definici\u00f3n de Alcance',
  'ct.step3Tag2': 'Mapeo de Stakeholders',
  'ct.step3Tag3': 'Propuesta Personalizada',
  'ct.step4Title': 'Su transformaci\u00f3n comienza',
  'ct.step4Desc': 'Iniciamos el compromiso de AI Value Discovery con un proceso estructurado: alineamiento ejecutivo, evaluaci\u00f3n de madurez de IA & datos, identificaci\u00f3n y priorizaci\u00f3n de casos de uso, arquitectura objetivo y modelado de impacto financiero. En 6\u201310 semanas, tiene un plan listo para la junta.',
  'ct.step4Tag1': 'AI Maturity Score',
  'ct.step4Tag2': 'Portafolio de Casos de Uso',
  'ct.step4Tag3': 'Architecture Blueprint',
  'ct.step4Tag4': 'Financial Impact Model',
  'ct.step4Tag5': 'Roadmap 18\u201336 Meses',

  // End state
  'ct.endLabel': 'Estado Final',
  'ct.endTitle': 'Su organizaci\u00f3n, {em}data-driven{/em} y lista para capturar valor a escala con IA.',

  // Contact Form
  'form.name': 'Nombre',
  'form.company': 'Empresa',
  'form.role': 'Cargo / T\u00edtulo',
  'form.email': 'Correo electr\u00f3nico',
  'form.industry': 'Industria',
  'form.selectIndustry': 'Seleccione su industria',
  'form.challenge': '\u00bfCu\u00e1l es su mayor desaf\u00edo de IA/datos en este momento?',
  'form.challengePlaceholder': 'Describa su situaci\u00f3n actual, objetivos o bloqueos...',
  'form.namePlaceholder': 'Su nombre',
  'form.companyPlaceholder': 'Nombre de la empresa',
  'form.rolePlaceholder': 'Su cargo',
  'form.emailPlaceholder': 'usted@empresa.com',
  'contact.namePlaceholder': 'Juan García',
  'contact.emailPlaceholder': 'juan@empresa.com',
  'contact.companyPlaceholder': 'Empresa S.A.',
  'contact.phonePlaceholder': '+34 600 000 000',
  'contact.messagePlaceholder': 'Cuéntenos sobre sus desafíos de datos e IA...',
  'form.submit': 'Solicitar AI Value Discovery',
  'form.submitting': 'Enviando...',
  'form.successLabel': 'Recibimos su contacto',
  'form.successTitle': 'Hemos recibido su solicitud.',
  'form.successBody': 'Un especialista senior revisar\u00e1 su env\u00edo y se pondr\u00e1 en contacto en 24 horas para programar una conversaci\u00f3n de descubrimiento. Est\u00e9 atento a su bandeja de entrada.',
  'form.directEmail': 'O cont\u00e1ctenos directamente:',

  // Form industries dropdown
  'form.indRetail': 'Retail & E-commerce',
  'form.indFinancial': 'Servicios Financieros',
  'form.indLogistics': 'Log\u00edstica & Cadena de Suministro',
  'form.indManufacturing': 'Manufactura / Industrial',
  'form.indHealthcare': 'Salud',
  'form.indB2B': 'B2B / SaaS / Servicios',
  'form.indStartups': 'Startups & Scale-ups',
  'form.indOther': 'Otro',
} as const;
